import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { computed, inject, Injectable, signal, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BehaviorSubject, catchError, EMPTY, finalize, map, Observable, tap } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '@env/environment';
import { UserTypeEnum } from 'app/core/enums/user.enum';
import { SocketService } from 'app/features/user/services/socket.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  toaster = inject(ToastrService);
  user_type = signal<UserTypeEnum | string>(UserTypeEnum.FREELANCER);
  signup_personal_info_form = signal<any>({});
  public currentUserSubject!: BehaviorSubject<any>;
  public currentUser!: Observable<any>;
  private isRefreshing = false;

  /** Signal-based current user; updates when login/logout/verify changes user state. */
  readonly currentUserSignal: Signal<any>;
  readonly currentUserIdSignal: Signal<number | undefined>;
  readonly currentUserNameSignal: Signal<string | undefined>;
  socketService = inject(SocketService);
  constructor(
    private http: HttpClient,
    private router: Router
  ) {
    const storedUser = JSON.parse(localStorage.getItem(environment.currentUserKey) || '{}');
    this.currentUserSubject = new BehaviorSubject<any>(storedUser);
    this.currentUser = this.currentUserSubject.asObservable();
    this.currentUserSignal = toSignal(this.currentUser, {
      initialValue: this.currentUserSubject.value,
    });
    this.currentUserIdSignal = computed(() => this.currentUserSignal()?.user?.id);
    this.currentUserNameSignal = computed(() => this.currentUserSignal()?.user?.username);
  }

  // Access Token management starts
  private accessToken = signal<string | null>(null);

  setAccessToken(token: string) {
    this.accessToken.set(token);
  }

  getAccessToken() {
    return this.accessToken();
  }
  // Access Token management ends

  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }
  changeType(value: string) {
    this.user_type.set(value);
  }

  saveSignupInfo(form: any) {
    this.signup_personal_info_form.set(form);
  }
  // signup
  signup(form: any) {
    const formData = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      formData.append(key, value as any);
    });
    return this.http.post(`${environment.endpoint}/auth/register`, formData);
  }

  // check-register
  checkRegister(form: any) {
    const formData = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      formData.append(key, value as any);
    });
    return this.http.post(`${environment.endpoint}/auth/check-register`, formData);
  }
  // login
  loginFreelance(form: any) {
    const formData = new FormData();
    formData.append('email', form.email);
    formData.append('password', form.password);

    return this.http.post(`${environment.endpoint}/auth/freelancers/login`, formData).pipe(
      map((user: any) => {
        if (user && user.data.token) {
          // Update local storage
          this.currentUserSubject.next(user.data); // Update BehaviorSubject
          localStorage.setItem('ShuwierToken', user.data.token);
          // this.setAccessToken(user.data.token);
          localStorage.setItem(environment.currentUserKey, JSON.stringify(user.data));
        }
        return user;
      })
    );
  }

  login(form: any) {
    const formData = new FormData();
    formData.append('email', form.email);
    formData.append('password', form.password);
    // Form.append('type', form.type);
    return this.http.post(`${environment.endpoint}/auth/login`, formData).pipe(
      map((user: any) => {
        if (user && user.data.token) {
          // Update local storage
          this.currentUserSubject.next(user.data); // Update BehaviorSubject
          localStorage.setItem('ShuwierToken', user.data.token);
          // this.setAccessToken(user.data.token);
          this.socketService.connect(user.data.token);
          localStorage.setItem(environment.currentUserKey, JSON.stringify(user.data));
        }
        return user;
      })
    );
  }
  firstPageAfterLogin() {
    let userType = this.currentUserValue?.user?.type;
    if (this.currentUserValue?.user && userType === 'freelancer') {
      console.log('from SP path');

      this.router.navigate(['/freelancer/projects']);
    } else {
      console.log('from client path');

      this.router.navigate(['/client/services']);
    }
    console.log('firstPageAfterLogin', userType);
  }
  socialMediaWithGoogle(state: any, type?: any) {
    let params = new HttpParams();
    if (state == 'register') {
      params = params.set('state', state);
      params = params.set('type', type);
    } else {
      params = params.set('state', state);
    }

    return this.http.get(`${environment.endpoint}/auth/google/redirect`, {
      params,
    });
  }

  getSocialMediaTokenLogin(temp_key: any) {
    const formData = new FormData();
    formData.append('temp_key', temp_key);
    return this.http.post(`${environment.endpoint}/auth/login/finalize`, formData);
  }

  getSocialMediaTokenSignup(user_name: any, temp_key: any) {
    const formData = new FormData();
    formData.append('username', user_name);
    formData.append('temp_key', temp_key);
    return this.http.post(`${environment.endpoint}/auth/register/finalize`, formData);
  }

  // Apple Section

  socialMediaWithApple(state: any, type?: any) {
    let params = new HttpParams();
    if (state == 'register') {
      params = params.set('state', state);
      params = params.set('type', type);
    } else {
      params = params.set('state', state);
    }

    return this.http.get(`${environment.endpoint}/auth/apple/redirect`, {
      params,
    });
  }

  // verify-change-email
  verifyChangeEmail(form: any, url?: string) {
    const formData = new FormData();
    formData.append('email', form.email);
    formData.append('otp', form.otp);

    return this.http.post(`${environment.endpoint}/auth/verify-change-email`, formData).pipe(
      map((res: any) => {
        console.log(res);
        return res;
      })
    );
    // }
  }

  // verify-email
  verifyEmail(form: any, url?: string) {
    const formData = new FormData();
    formData.append('email', form.email);
    formData.append('otp', form.otp);
    // if (from === 'update-email') {
    //   return this.http.post(
    //     `${environment.endpoint}/auth/verify-change-email`,
    //     formData
    //   );
    // } else if (from === 'forget-password') {
    //   return this.http.post(
    //     `${environment.endpoint}/auth/verify-email`,
    //     formData
    //   );
    // } else {
    const endpoint = url ? url : 'verify-email';

    return this.http.post(`${environment.endpoint}/auth/${endpoint}`, formData).pipe(
      map((user: any) => {
        if (user && user?.data?.token) {
          // Update local storage
          this.currentUserSubject.next(user?.data); // Update BehaviorSubject
          localStorage.setItem('ShuwierToken', user?.data?.token);
          // this.setAccessToken(user?.data?.token);
          localStorage.setItem(environment.currentUserKey, JSON.stringify(user?.data));
        }
        return user;
      })
    );
    // }
  }
  // forget password
  forgetPassword(form: any) {
    const formData = new FormData();
    formData.append('email', form.email);

    return this.http.post(`${environment.endpoint}/auth/forget-password`, formData).pipe(
      map((res: any) => {
        return res;
      })
    );
  }
  resetPassword(form: any) {
    const formData = new FormData();
    formData.append('email', form.email);
    formData.append('token', form.token);
    formData.append('password', form.password);
    formData.append('password_confirmation', form.password_confirmation);

    return this.http.post(`${environment.endpoint}/auth/reset-password`, formData).pipe(
      map((res: any) => {
        return res;
      })
    );
  }
  // auth/reset-email
  resetEmail(form: any) {
    const formData = new FormData();
    formData.append('old_email', form.old_email);
    formData.append('new_email', form.new_email);
    this.signup_personal_info_form.set({
      ...this.signup_personal_info_form(),
      email: form.new_email,
    });
    return this.http.post(`${environment.endpoint}/auth/reset-email`, formData).pipe(
      map((res: any) => {
        return res;
      })
    );
  }
  resendCode(form: any) {
    const formData = new FormData();
    formData.append('email', form.email);

    return this.http.post(`${environment.endpoint}/auth/resend-code`, formData).pipe(
      map((res: any) => {
        return res;
      })
    );
  }
  // auth/change-password
  changePassword(form: any) {
    const formData = new FormData();
    // formData.append('current_password', form.current_password);
    if (form.current_password !== undefined && form.current_password !== null) {
      formData.append('current_password', form.current_password);
    }
    formData.append('new_password', form.new_password);
    formData.append('new_password_confirmation', form.new_password_confirmation);

    return this.http.post(`${environment.endpoint}/auth/change-password`, formData).pipe(
      map((res: any) => {
        return res;
      })
    );
  }
  updateProfile(form: any) {
    const formData = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        if (key == 'phone') {
          value = value;
        }
        formData.append(key, value as any);
      }
    });
    return this.http.post(`${environment.endpoint}/auth/profile`, formData).pipe(
      map((res: any) => {
        return res;
      })
    );
  }
  refreshToken() {
    return this.http.post(`${environment.endpoint}/auth/refresh`, {}).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  refreshAndUpdateSession(): Observable<void> {
    if (this.isRefreshing) {
      return EMPTY;
    }

    this.isRefreshing = true;

    return this.refreshToken().pipe(
      map((res: any) => {
        const token = res?.data?.token;

        if (token) {
          localStorage.setItem('ShuwierToken', token);
          // this.setAccessToken(token);
        }
        console.log('Fininsh Refresh tokwn and localstorage update');
      }),
      finalize(() => {
        this.isRefreshing = false;
      }),
      catchError((err) => {
        this.isRefreshing = false;
        this.logoutLocal();
        return EMPTY;
      })
    );
  }
  changeEmail(form: any) {
    const formData = new FormData();
    formData.append('email', form.email);
    // formData.append('password', form.password);
    formData.append('email_confirmation', form.email_confirmation);
    return this.http.post(`${environment.endpoint}/auth/change-email`, formData).pipe(
      map((res: any) => {
        return res;
      })
    );
  }
  patchStoredUser(patch: Record<string, unknown>): void {
    const current = this.currentUserSubject.value;
    if (!current) return;
    const updated = { ...current, user: { ...current.user, ...patch } };
    this.currentUserSubject.next(updated);
    localStorage.setItem(environment.currentUserKey, JSON.stringify(updated));
    console.log('Updated stored user:', updated);
  }

  logoutLocal() {
    this.clearSession();
    this.currentUserSubject.next(null);
    this.router.navigate(['/auth/login'], {
      replaceUrl: true,
    });
  }
  logout() {
    return this.http.post<any>(`${environment.endpoint}/auth/logout`, {}).pipe(
      tap(() => {
        this.logoutLocal();
        this.toaster.success('Logged out successfully');
      })
    );
  }
  clearSession() {
    localStorage.clear();
  }
}
